<template>
  <div class="sass-config-container">
    <div
      class="user-list-box"
      :class="expandedArrow ? '' : 'openTree'">
      <div
        class="user-list-box-tree"
        v-show="expandedArrow">
        <p>用户列表</p>
        <div class="common-input-box">
          <el-input
            class="search-input input-primary"
            size="mini"
            v-model="surname"
            placeholder="请输入用户名称"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search" />
          </el-input>
        </div>

        <ul class="list-box">
          <li
            v-for="(item, index) in userList"
            :key="index"
            :class="`${selectUserInfo.userId === item.userId ? 'active' : ''}`"
            @click="onUserClick(item)">
            {{ item.surname }}
          </li>
        </ul>
      </div>
      <div
        class="expaned"
        @click="() => (expandedArrow = !expandedArrow)">
        <i
          v-if="!expandedArrow"
          size="14"
          class="el-icon-arrow-right el-icon"></i>
        <i
          v-else
          size="14"
          class="el-icon-arrow-left el-icon"></i>
      </div>
    </div>
    <div
      class="user-config-box outer-page-primary"
      :style="{ width: expandedArrow ? 'calc(100% - 276px)' : '100%' }">
      <div
        class="user-config-box-content"
        v-if="selectUserInfo.userId">
        <div class="common-button-box">
          <el-button
            size="small"
            class="negative-btn normal-btn"
            @click="resetUserConfig"
            >重置</el-button
          >
          <el-button
            size="small"
            type="primary"
            class="primary-btn"
            @click="save"
            >保存</el-button
          >
          <div class="import-tips public-tips-primary">
            (注意：对于所有数量，设置为“-1”代表不做限制)
          </div>
        </div>

        <div class="config-item-box">
          <div class="title first-title">
            <div class="icon">
              <img
                src="@/assets/icon/useLimit.png"
                alt="" />
            </div>
            <span class="text searchLabel">全局限制（针对单个用户有效）</span>
            <div class="extra-data">
              <span class="searchLabel">有效期截止时间：</span>
              <div>
                <el-date-picker
                  class="date-picker-primary"
                  v-model="warranty.effectiveDate"
                  type="date"
                  size="mini"
                  popper-class="datepicker-popper-box"
                  :append-to-body="false"
                  placeholder="选择日期" />
              </div>
            </div>
          </div>
          <div class="content">
            <div class="project-config input-gap">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="config-item">
                    <span
                      class="label searchLabel"
                      style="width: 164px; text-align: right"
                      >单项目数量(个)：</span
                    >
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="projects.projectCountLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="config-item">
                    <span
                      class="label searchLabel"
                      style="margin-left: 18px"
                      >集群项目数量(个)：</span
                    >
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="projects.clusterCountLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="config-item">
                    <span class="label searchLabel">场景数量(个)：</span>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="projects.sceneCountLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="config-item">
                    <span class="label searchLabel">数据集数量(个)：</span>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="projects.dataSetCountLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="project-config input-gap">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="config-item">
                    <span class="label searchLabel">文件总大小(GB)：</span>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="projects.totalFileSizeLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="config-item">
                    <span
                      class="label searchLabel"
                      style="margin-left: 10px"
                      >单个文件大小(MB)：</span
                    >
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="warranty.globalFileUploadSizeLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="config-item">
                    <span class="label searchLabel">文件数量(个)：</span>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="projects.fileCountLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="config-item">
                    <span class="label searchLabel"
                      >同时上传文件个数(个)：</span
                    >
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="warranty.globalFileUploadingTaskLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="project-config input-gap">
              <div class="config-item">
                <span class="label searchLabel">单个文件上传速度(MB/s)：</span>
                <el-input-number
                  class="input-number-primary signFile"
                  controls-position="right"
                  size="mini"
                  v-model="warranty.globalFileUploadingSpeedLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span class="label searchLabel">转换队列优先级(个)：</span>
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="warranty.convertsQueuePriority"
                  :min="0"></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="config-item-box">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/icon/projectLimit.png"
                alt="" />
            </div>
            <span class="text searchLabel">单项目限制</span>
          </div>
          <div class="content fileContent">
            <div class="use-config input-gap">
              <div class="config-item">
                <span class="label searchLabel">文件数量(个)：</span>
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.fileCountPerProjectLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span class="label searchLabel">数据集数量(个)：</span>
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.dataSetCountPerProjectLimit"
                  :min="-1"></el-input-number>
              </div>
              <div class="config-item">
                <span class="label searchLabel">场景数量(个)：</span>
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="projects.sceneCountPerProjectLimit"
                  :min="-1"></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="config-item-box">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/icon/datasetLimit.png"
                alt="" />
            </div>
            <span class="text searchLabel">单项目数据集类型</span>
          </div>
          <div class="common-bussiness-collapse-box">
            <el-collapse v-model="activeTypes">
              <el-collapse-item name="bim">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('bim') ? 'is-active' : ''
                      }`"></i>
                    <span class="modelArrow searchLabel">BIM模型</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('bim', value)"
                      v-model="dataSets.bim.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div
                  class="dataset-config"
                  style="margin-bottom: 12px">
                  <div class="label searchLabel">数据集数量(个)：</div>
                  <el-input-number
                    class="input-number-primary"
                    controls-position="right"
                    size="mini"
                    @change="value => handleInputChange('bim', value)"
                    v-model="dataSets.bim.dataSetLimit"
                    :min="-1"></el-input-number>
                </div>
                <div class="dataset-config">
                  <div
                    class="label searchLabel"
                    style="margin-left: 39px">
                    数据来源：
                  </div>
                  <el-checkbox
                    class="select-all checkbox-primary"
                    :indeterminate="bimSourceIndeterminate"
                    :value="bimSourceSelectAll"
                    @change="
                      value => handleSelectAllChange('bim', 'source', value)
                    "
                    >全选</el-checkbox
                  >
                  <div class="checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in bimSourceList"
                      :key="index"
                      :value="isConfigChecked('bim', 'source', item)"
                      @change="
                        value =>
                          handleDataConfigCheckChange(
                            'bim',
                            'source',
                            item,
                            value
                          )
                      "
                      >{{ item.typeName }}</el-checkbox
                    >
                  </div>
                </div>
                <div class="dataset-config">
                  <div
                    class="label searchLabel"
                    style="margin-left: 40px">
                    文件类型：
                  </div>
                  <el-checkbox
                    class="select-all checkbox-primary"
                    :indeterminate="bimExtensionIndeterminate"
                    :value="bimExtensionSelectAll"
                    @change="
                      value => handleSelectAllChange('bim', 'extension', value)
                    "
                    >全选</el-checkbox
                  >
                  <div
                    class="checkbox-gap"
                    style="margin-left: 122px">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in bimExtensionList"
                      :key="index"
                      :value="isConfigChecked('bim', 'extension', item)"
                      @change="
                        value =>
                          handleDataConfigCheckChange(
                            'bim',
                            'extension',
                            item,
                            value
                          )
                      "
                      >{{ item.extension }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="rs">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('rs') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel modelArrow">遥感数据</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('rs', value)"
                      v-model="dataSets.rs.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="label searchLabel">数据集数量(个)：</div>
                  <el-input-number
                    class="input-number-primary"
                    controls-position="right"
                    size="mini"
                    @change="value => handleInputChange('rs', value)"
                    v-model="dataSets.rs.dataSetLimit"
                    :min="-1"></el-input-number>
                </div>
              </el-collapse-item>
              <el-collapse-item name="wmts">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('wmts') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel modelArrow">WMTS地图服务</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('wmts', value)"
                      v-model="dataSets.wmts.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="label searchLabel">数据集数量(个)：</div>
                  <el-input-number
                    class="input-number-primary"
                    controls-position="right"
                    size="mini"
                    @change="value => handleInputChange('wmts', value)"
                    v-model="dataSets.wmts.dataSetLimit"
                    :min="-1"></el-input-number>
                </div>
              </el-collapse-item>
              <el-collapse-item name="osgb">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('osgb') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel modelArrow">倾斜摄影</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('osgb', value)"
                      v-model="dataSets.osgb.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="label searchLabel">数据集数量(个)：</div>
                  <el-input-number
                    class="input-number-primary"
                    controls-position="right"
                    size="mini"
                    @change="value => handleInputChange('osgb', value)"
                    v-model="dataSets.osgb.dataSetLimit"
                    :min="-1"></el-input-number>
                </div>
              </el-collapse-item>
              <el-collapse-item name="panorama">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('panorama') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel modelArrow">360全景图</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('panorama', value)"
                      v-model="dataSets.panorama.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="label searchLabel">数据集数量(个)：</div>
                  <el-input-number
                    class="input-number-primary"
                    controls-position="right"
                    size="mini"
                    @change="value => handleInputChange('panorama', value)"
                    v-model="dataSets.panorama.dataSetLimit"
                    :min="-1"></el-input-number>
                </div>
              </el-collapse-item>
              <el-collapse-item name="pointCloud">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('pointCloud') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel modelArrow">点云</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('pointCloud', value)"
                      v-model="dataSets.pointCloud.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="label searchLabel">数据集数量(个)：</div>
                  <el-input-number
                    class="input-number-primary"
                    controls-position="right"
                    size="mini"
                    @change="value => handleInputChange('pointCloud', value)"
                    v-model="dataSets.pointCloud.dataSetLimit"
                    :min="-1"></el-input-number>
                </div>
                <div class="dataset-config">
                  <div
                    class="label searchLabel"
                    style="margin-left: 38px">
                    数据来源：
                  </div>
                  <el-checkbox
                    class="select-all checkbox-primary"
                    :indeterminate="pointCloudSourceIndeterminate"
                    :value="pointCloudSourceSelectAll"
                    @change="
                      value =>
                        handleSelectAllChange('pointCloud', 'source', value)
                    "
                    >全选</el-checkbox
                  >
                  <div class="checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in pointCloudSourceList"
                      :key="index"
                      :value="isConfigChecked('pointCloud', 'source', item)"
                      @change="
                        value =>
                          handleDataConfigCheckChange(
                            'pointCloud',
                            'source',
                            item,
                            value
                          )
                      "
                      >{{ item.typeName }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="cad">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('cad') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel modelArrow">二维图纸</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('cad', value)"
                      v-model="dataSets.cad.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="label searchLabel">数据集数量(个)：</div>
                  <el-input-number
                    class="input-number-primary"
                    controls-position="right"
                    size="mini"
                    @change="value => handleInputChange('cad', value)"
                    v-model="dataSets.cad.dataSetLimit"
                    :min="-1"></el-input-number>
                </div>
                <div class="dataset-config">
                  <div
                    class="label searchLabel"
                    style="margin-left: 38px">
                    文件类型：
                  </div>
                  <el-checkbox
                    class="select-all checkbox-primary"
                    :indeterminate="cadExtensionIndeterminate"
                    :value="cadExtensionSelectAll"
                    @change="
                      value => handleSelectAllChange('cad', 'extension', value)
                    "
                    >全选</el-checkbox
                  >
                  <div class="checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in cadExtensionList"
                      :key="index"
                      :value="isConfigChecked('cad', 'extension', item, 1)"
                      @change="
                        value =>
                          handleDataConfigCheckChange(
                            'cad',
                            'extension',
                            item,
                            value
                          )
                      "
                      >{{ item.extension }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="vector">
                <template slot="title">
                  <div>
                    <i
                      :class="`collapse__arrow el-icon-arrow-down ${
                        activeTypes.includes('vector') ? 'is-active' : ''
                      }`"></i>
                    <span class="searchLabel modelArrow">矢量数据</span>
                  </div>
                  <div @click="e => e.stopPropagation()">
                    <span class="searchLabel">是否启用：</span>
                    <el-switch
                      class="switch-primary"
                      @change="value => handleSwitchChange('vector', value)"
                      v-model="dataSets.vector.enable"
                      active-color="#077ffe"
                      inactive-color="#b7b7b7">
                    </el-switch>
                  </div>
                </template>
                <div class="dataset-config">
                  <div class="label searchLabel">数据集数量(个)：</div>
                  <el-input-number
                    class="input-number-primary"
                    controls-position="right"
                    size="mini"
                    @change="value => handleInputChange('vector', value)"
                    v-model="dataSets.vector.dataSetLimit"
                    :min="-1"></el-input-number>
                </div>
                <div class="dataset-config">
                  <div
                    class="label searchLabel"
                    style="margin-left: 38px">
                    文件类型：
                  </div>
                  <el-checkbox
                    class="select-all checkbox-primary"
                    :indeterminate="vectorExtensionIndeterminate"
                    :value="vectorExtensionSelectAll"
                    @change="
                      value =>
                        handleSelectAllChange('vector', 'extension', value)
                    "
                    >全选</el-checkbox
                  >
                  <div class="checkbox-gap">
                    <el-checkbox
                      class="checkbox-primary checkbox-source"
                      v-for="(item, index) in vectorExtensionList"
                      :key="index"
                      :value="isConfigChecked('vector', 'extension', item, 1)"
                      @change="
                        value =>
                          handleDataConfigCheckChange(
                            'vector',
                            'extension',
                            item,
                            value
                          )
                      "
                      >{{ item.extension }}</el-checkbox
                    >
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div class="config-item-box">
          <div class="config-item-title-box">
            <div class="title">
              <div class="icon">
                <img
                  src="@/assets/icon/projectLimit.png"
                  alt="" />
              </div>
              <span class="text searchLabel">
                构件库菜单(大小和数量限制仅针对我的构件有效)
              </span>
            </div>
            <div class="common-switch-box">
              <span class="searchLabel">是否启用：</span>
              <el-switch
                class="switch-primary"
                v-model="componentLibrary.enable">
              </el-switch>
            </div>
          </div>
          <div class="content">
            <div class="use-config input-gap">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="config-item">
                    <span class="label searchLabel">文件总大小(GB)：</span>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="componentLibrary.privateClTotalFileSizeLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="config-item">
                    <span class="label searchLabel">单个文件大小(MB)：</span>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="componentLibrary.privateClFileUploadSizeLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="config-item">
                    <span class="label searchLabel">文件数量(个)：</span>
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="componentLibrary.privateClFileCountLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="config-item">
                    <span class="label searchLabel"
                      >同时上传文件个数(个)：</span
                    >
                    <el-input-number
                      class="input-number-primary"
                      controls-position="right"
                      size="mini"
                      v-model="componentLibrary.privateClFileUploadingTaskLimit"
                      :min="-1"></el-input-number>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="config-item-box">
          <div class="config-item-title-box">
            <div class="title">
              <div class="icon">
                <img
                  src="@/assets/icon/projectLimit.png"
                  alt="" />
              </div>
              <span class="text searchLabel">数据迁移</span>
            </div>
            <div class="common-switch-box">
              <span class="searchLabel">是否启用：</span>
              <el-switch
                class="switch-primary"
                v-model="exportPublish.enable">
              </el-switch>
            </div>
          </div>
          <div class="content">
            <div class="use-config">
              <div class="config-item">
                <span class="long-lable searchLabel"
                  >导出数据集/场景/项目信息次数：</span
                >
                <el-input-number
                  class="input-number-primary"
                  controls-position="right"
                  size="mini"
                  v-model="exportPublish.exportCountLimit"
                  :min="-1"></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="config-item-box">
          <div class="title">
            <div class="icon">
              <img
                src="@/assets/icon/devLimit.png"
                alt="" />
            </div>
            <span class="text searchLabel">开发限制</span>
          </div>
          <div class="content">
            <div class="develop-config">
              <div class="config-item">
                <span class="searchLabel">开放转换接口：</span>
                <el-switch
                  class="switch-primary"
                  v-model="develop.serverAdvancedInterface"
                  active-color="#077ffe"
                  inactive-color="#b7b7b7">
                </el-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getUserList,
  getSassConfigInfo,
  createSassConfig,
  modifySassConfig
} from '@/service/interface'

export default {
  data() {
    return {
      surname: '',
      userList: [],
      selectUserInfo: {},
      expandedArrow: true,
      activeTypes: [
        'bim',
        'rs',
        'wmts',
        'osgb',
        'panorama',
        'pointCloud',
        'cad',
        'vector'
      ],
      bimSourceIndeterminate: false,
      bimSourceSelectAll: false,
      bimExtensionIndeterminate: false,
      bimExtensionSelectAll: false,
      pointCloudSourceIndeterminate: false,
      pointCloudSourceSelectAll: false,
      cadExtensionIndeterminate: false,
      cadExtensionSelectAll: false,
      vectorExtensionIndeterminate: false,
      vectorExtensionSelectAll: false,
      dataSets: {
        bim: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            },
            texture: {
              name: '纹理动画',
              enable: true
            },
            renderPriority: {
              name: '渲染优先级',
              enable: true
            }
          }
        },
        rs: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        wmts: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            add: {
              name: '新增地图',
              enable: true
            },
            edit: {
              name: '编辑',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        osgb: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        panorama: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        },
        pointCloud: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        },
        cad: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        vector: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        }
      },
      projects: {
        projectCountLimit: 0,
        clusterCountLimit: 0,
        sceneCountLimit: 0,
        dataSetCountLimit: 0,
        fileCountLimit: 0,
        totalFileSizeLimit: 0,
        fileCountPerProjectLimit: 0,
        dataSetCountPerProjectLimit: 0,
        sceneCountPerProjectLimit: 0
      },
      componentLibrary: {
        enable: false,
        privateClFileCountLimit: 0,
        privateClFileUploadSizeLimit: 0,
        privateClFileUploadingTaskLimit: 0,
        privateClTotalFileSizeLimit: 0
      },
      warranty: {
        effectiveDate: '',
        globalFileUploadingTaskLimit: 0,
        globalFileUploadingSpeedLimit: 0,
        globalFileUploadSizeLimit: 0,
        convertsQueuePriority: 0
      },
      develop: {
        serverAdvancedInterface: false
      },
      exportPublish: {
        enable: false,
        isPublishPlatform: false,
        exportCountLimit: 0,
        menu: {
          exportPage: {
            name: '导出页面',
            enable: false
          },
          importPage: {
            name: '导入页面',
            enable: false
          }
        },
        platformId: '',
        platformUuid: ''
      },
      scene: {
        menu: {
          addComponentLibrary: {
            name: '添加单构件模型',
            enable: false
          },
          publish: {
            name: '发布场景',
            enable: false
          }
        }
      },

      bimSourceList: [
        { typeName: 'revit', value: false },
        { typeName: 'navisworks', value: false },
        { typeName: '3dsmax', value: false },
        { typeName: 'rhino', value: false },
        { typeName: 'dgn', value: false },
        { typeName: 'bimplugin', value: false },
        { typeName: 'online', value: false }
      ],
      bimExtensionList: [
        { extension: '.rvt', value: false },
        { extension: '.pak', value: false },
        { extension: '.3dxml', value: false },
        { extension: '.gim', value: false },
        { extension: '.ifc', value: false },
        { extension: '.igms', value: false },
        { extension: '.fbx', value: false },
        { extension: '.gltf', value: false },
        { extension: '.stp', value: false },
        { extension: '.3dm', value: false },
        { extension: '.skp', value: false },
        { extension: '.glb', value: false },
        { extension: '.dgn', value: false },
        { extension: '.nwd', value: false },
        { extension: '.nwc', value: false },
        { extension: '.rvm', value: false },
        { extension: '.obj', value: false },
        { extension: '.obj.zip', value: false },
        { extension: '.stl', value: false },
        { extension: '.cdm', value: false }
      ],
      pointCloudSourceList: [
        { typeName: '.asc', value: false },
        { typeName: '.pts', value: false },
        { typeName: '.las', value: false },
        { typeName: '.e57', value: false },
        { typeName: '.pcd', value: false },
        { typeName: '.ply', value: false }
      ],
      cadExtensionList: [
        { extension: '.dwg', value: false },
        { extension: '.dxf', value: false },
        { extension: '.pdf', value: false }
      ],
      vectorExtensionList: [
        { extension: '.shp.zip', value: false },
        { extension: '.kml', value: false },
        { extension: '.kmz', value: false }
      ]
    }
  },
  created() {
    this.queryUserList()
  },
  methods: {
    queryUserList() {
      let params = {
        maxResultCount: 1000,
        skipCount: 0,
        sorting: '',
        searchType: 'surname',
        filter: this.surname
      }
      getUserList(params).then(res => {
        if (res.status === 200) {
          let data = res.data
          if (data.isSuccess) {
            this.userList = data.data.items
            this.onUserClick(this.userList[0])
          }
        }
      })
    },
    search() {
      this.queryUserList()
    },
    onUserClick(userInfo) {
      this.resetAllConfig()
      getSassConfigInfo(userInfo.userId).then(response => {
        if (response.isSuccess) {
          let data = response.data
          if (data.initializeDeploy) {
            this.dataSets = data.initializeDeploy.dataSets
            this.projects = data.initializeDeploy.projects
            this.componentLibrary = data.initializeDeploy.componentLibrary
            this.warranty = data.initializeDeploy.warranty
            this.develop = data.initializeDeploy.develop
            if (data.initializeDeploy.exportPublish) {
              let config = data.initializeDeploy.exportPublish
              let exportPublish = {
                enable: config.enable,
                exportCountLimit: config.exportCountLimit,
                isPublishPlatform: config.isPublishPlatform,
                platformId: '',
                platformUuid: '',
                menu: this.exportPublish.menu
              }
              this.exportPublish = exportPublish
            }
          }
          this.selectUserInfo = {
            userId: userInfo.userId,
            id: data.id,
            config: data.initializeDeploy
          }
        }
      })
    },
    handleSwitchChange(dataType, value) {
      let dataInfo = this.dataSets[dataType]
      if (!value) {
        dataInfo.dataSetLimit = 0
      }
    },
    handleInputChange(dataType, value) {
      let dataInfo = this.dataSets[dataType]
      if (value > 0) {
        dataInfo.enable = true
      }
    },
    handleSelectAllChange(dataType, field, value) {
      let dataInfo = this.dataSets[dataType]
      let fieldValue = dataInfo[field]
      if (value) {
        dataInfo.enable = true
        if (field === 'source') {
          if (dataType === 'bim') {
            this.bimSourceList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.typeName === item.typeName)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
          if (dataType === 'pointCloud') {
            this.pointCloudSourceList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.typeName === item.typeName)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
        } else {
          if (dataType === 'bim') {
            this.bimExtensionList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.extension === item.extension)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
          if (dataType === 'pointCloud') {
            this.pointCloudSourceList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.extension === item.extension)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
          if (dataType === 'cad') {
            this.cadExtensionList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.extension === item.extension)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
          if (dataType === 'vector') {
            this.vectorExtensionList.forEach(item => {
              item.value = true
              let find = fieldValue.find(el => el.extension === item.extension)
              if (!find) {
                fieldValue.push(item)
              } else {
                find.value = true
              }
            })
          }
        }
      } else {
        dataInfo[field] = []
      }
    },
    handleDataConfigCheckChange(dataType, field, dataConfig, value) {
      this.$delete(dataConfig, 'value')
      this.$set(dataConfig, 'value', value)

      let data = this.dataSets[dataType]
      let fieldValue = data[field]
      let find = null
      if (field === 'source') {
        find = fieldValue.find(el => el.typeName === dataConfig.typeName)
      } else {
        find = fieldValue.find(el => el.extension === dataConfig.extension)
      }
      if (!find) {
        fieldValue.push(dataConfig)
      } else {
        find.value = value
      }

      let enable = fieldValue.some(el => el.value)
      if (enable) {
        this.dataSets[dataType].enable = enable
      }
    },
    isConfigChecked(dataType, field, dataConfig) {
      const extensionFilter = ['.gmc', '.gbp', '.zip', '.iam', '.ipt']

      let dataInfo = this.dataSets[dataType]
      if (!dataInfo.enable) {
        if (field === 'source') {
          if (dataType === 'bim') {
            this.bimSourceIndeterminate = false
            this.bimSourceSelectAll = false
          }
          if (dataType === 'pointCloud') {
            this.pointCloudSourceIndeterminate = false
            this.pointCloudSourceSelectAll = false
          }
        } else {
          if (dataType === 'bim') {
            this.bimExtensionIndeterminate = false
            this.bimExtensionSelectAll = false
          }
          if (dataType === 'cad') {
            this.cadExtensionIndeterminate = false
            this.cadExtensionSelectAll = false
          }
          if (dataType === 'vector') {
            this.vectorExtensionIndeterminate = false
            this.vectorExtensionSelectAll = false
          }
        }

        dataInfo[field] = []
        return false
      }

      let fieldValue = dataInfo[field]
      fieldValue = fieldValue.filter(
        el => !extensionFilter.includes(el.extension)
      )
      let checkedArray = fieldValue.filter(el => el.value)
      let find = null
      if (field === 'source') {
        if (dataType === 'bim') {
          if (!checkedArray.length) {
            this.bimSourceIndeterminate = false
            this.bimSourceSelectAll = false
          } else {
            if (checkedArray.length === this.bimSourceList.length) {
              this.bimSourceIndeterminate = false
              this.bimSourceSelectAll = true
            }
            if (checkedArray.length < this.bimSourceList.length) {
              this.bimSourceIndeterminate = true
              this.bimSourceSelectAll = false
            }
          }
        }
        if (dataType === 'pointCloud') {
          if (!checkedArray.length) {
            this.pointCloudSourceIndeterminate = false
            this.pointCloudSourceSelectAll = false
          } else {
            if (checkedArray.length === this.pointCloudSourceList.length) {
              this.pointCloudSourceIndeterminate = false
              this.pointCloudSourceSelectAll = true
            }
            if (checkedArray.length < this.pointCloudSourceList.length) {
              this.pointCloudSourceIndeterminate = true
              this.pointCloudSourceSelectAll = false
            }
          }
        }
        find = fieldValue.find(el => el.typeName === dataConfig.typeName)
      } else {
        if (dataType === 'bim') {
          if (!checkedArray.length) {
            this.bimExtensionIndeterminate = false
            this.bimExtensionSelectAll = false
          } else {
            if (checkedArray.length === this.bimExtensionList.length) {
              this.bimExtensionIndeterminate = false
              this.bimExtensionSelectAll = true
            }
            if (checkedArray.length < this.bimExtensionList.length) {
              this.bimExtensionIndeterminate = true
              this.bimExtensionSelectAll = false
            }
          }
        }
        if (dataType === 'cad') {
          if (!checkedArray.length) {
            this.cadExtensionIndeterminate = false
            this.cadExtensionSelectAll = false
          } else {
            if (checkedArray.length === this.cadExtensionList.length) {
              this.cadExtensionIndeterminate = false
              this.cadExtensionSelectAll = true
            }
            if (checkedArray.length < this.cadExtensionList.length) {
              this.cadExtensionIndeterminate = true
              this.cadExtensionSelectAll = false
            }
          }
        }
        if (dataType === 'vector') {
          if (!checkedArray.length) {
            this.vectorExtensionIndeterminate = false
            this.vectorExtensionSelectAll = false
          } else {
            if (checkedArray.length === this.vectorExtensionList.length) {
              this.vectorExtensionIndeterminate = false
              this.vectorExtensionSelectAll = true
            }
            if (checkedArray.length < this.vectorExtensionList.length) {
              this.vectorExtensionIndeterminate = true
              this.vectorExtensionSelectAll = false
            }
          }
        }
        find = fieldValue.find(el => el.extension === dataConfig.extension)
      }
      if (find) {
        return find.value
      } else {
        return false
      }
    },
    resetUserConfig() {
      let userInfo = this.selectUserInfo
      getSassConfigInfo(userInfo.userId).then(response => {
        if (response.isSuccess) {
          let data = response.data
          if (data.initializeDeploy) {
            this.dataSets = data.initializeDeploy.dataSets
            this.projects = data.initializeDeploy.projects
            this.componentLibrary = data.initializeDeploy.componentLibrary
            this.warranty = data.initializeDeploy.warranty
            this.develop = data.initializeDeploy.develop

            if (data.initializeDeploy.exportPublish) {
              let config = data.initializeDeploy.exportPublish
              let exportPublish = {
                enable: config.enable,
                exportCountLimit: config.exportCountLimit,
                isPublishPlatform: config.isPublishPlatform,
                platformId: '',
                platformUuid: '',
                menu: this.exportPublish.menu
              }
              this.exportPublish = exportPublish
            }
          }
        }
      })
    },
    save() {
      if (!this.warranty.effectiveDate) {
        this.$message.error('有效期截止时间不能为空！！！')
        return
      }
      let userInfo = this.selectUserInfo
      if (!userInfo.config) {
        let config = {}
        config['dataSets'] = this.dataSets
        config['projects'] = this.projects
        config['scene'] = this.scene
        config['componentLibrary'] = this.componentLibrary
        if (this.warranty.effectiveDate) {
          this.warranty.effectiveDate = this.warranty.effectiveDate.toJSON()
        }
        config['warranty'] = this.warranty
        config['develop'] = this.develop
        config['exportPublish'] = this.exportPublish
        userInfo.config = config
        createSassConfig(userInfo).then(response => {
          if (response.isSuccess) {
            let result = response.data
            if (result.initializeDeploy) {
              this.dataSets = result.initializeDeploy.dataSets
              this.projects = result.initializeDeploy.projects
              this.componentLibrary = result.initializeDeploy.componentLibrary
              this.warranty = result.initializeDeploy.warranty
              this.develop = result.initializeDeploy.develop
              if (result.initializeDeploy.exportPublish) {
                let config = result.initializeDeploy.exportPublish
                let exportPublish = {
                  enable: config.enable,
                  exportCountLimit: config.exportCountLimit,
                  isPublishPlatform: config.isPublishPlatform,
                  platformId: '',
                  platformUuid: '',
                  menu: this.exportPublish.menu
                }
                this.exportPublish = exportPublish
              }
            }
            this.selectUserInfo = {
              userId: result.userId,
              id: result.id,
              config: result.initializeDeploy
            }
            this.$message.success('创建配置成功！！！')
          }
        })
      } else {
        userInfo['id'] = this.selectUserInfo.id
        userInfo.config['dataSets'] = this.dataSets
        userInfo.config['projects'] = this.projects
        userInfo.config['scene'] = this.scene
        userInfo.config['componentLibrary'] = this.componentLibrary
        if (this.warranty.effectiveDate && this.warranty.effectiveDate.toJSON) {
          this.warranty.effectiveDate = this.warranty.effectiveDate.toJSON()
        }
        userInfo.config['warranty'] = this.warranty
        userInfo.config['develop'] = this.develop
        userInfo.config['exportPublish'] = this.exportPublish
        modifySassConfig(userInfo).then(response => {
          if (response.isSuccess) {
            this.$message.success('更新配置成功！！！')
          }
        })
      }
      // console.log(this.userList, "用户列表");

      // let user = this.userList.find(
      //   (el) => el.userId === "3a04dff0-9e2c-a4c6-5b6e-fe5f44bbf8de"
      // );
      // console.log(user);

      // // let testUserList = this.userList.filter((el, index) => index < 9);
      // let testUserList = [
      //   { userId: "3a04dff0-9e2c-a4c6-5b6e-fe5f44bbf8de" },
      //   { userId: "3a049113-f422-1a7b-c470-1c4a62af5923" },
      //   { userId: "3a057a26-d8b0-a22f-37f9-769955fa7153" },
      // ];
      // // let promiseArray = [];
      // // testUserList.forEach((item) => {
      // //   let promise = this.changeUserConfig(item);
      // //   promiseArray.push(promise);
      // // });
      // this.loopRequest(testUserList, 2);
    },
    changeUserConfig(userInfo) {
      return new Promise(resolve => {
        let userId = userInfo.userId
        getSassConfigInfo(userId).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let userInfo = {}
            if (data.initializeDeploy) {
              userInfo = { userId, id: data.id, config: data.initializeDeploy }
              userInfo.config['componentLibrary'] = {
                privateClFileCountLimit: 50,
                privateClFileUploadSizeLimit: 10,
                privateClFileUploadingTaskLimit: 10,
                privateClTotalFileSizeLimit: 1,
                publicClFileCountLimit: -1
              }
              modifySassConfig(userInfo).then(res => {
                if (res.isSuccess) {
                  resolve()
                }
              })
            }
          }
        })
      })
    },
    async loopRequest(arrayList, num) {
      let count = 0
      while (arrayList.length > 0) {
        const temp = arrayList.splice(0, num)
        await new Promise(resolve => setTimeout(resolve, 5000)) // 添加一个延迟等待时间
        try {
          temp.forEach(item => {
            this.changeUserConfig(item)
          })
        } catch (error) {
          console.error(error)
        }
        count += num
      }
    },
    resetAllConfig() {
      this.bimSourceIndeterminate = false
      this.bimSourceSelectAll = false
      this.bimExtensionIndeterminate = false
      this.bimExtensionSelectAll = false
      this.pointCloudSourceIndeterminate = false
      this.pointCloudSourceSelectAll = false
      this.cadExtensionIndeterminate = false
      this.cadExtensionSelectAll = false
      this.vectorExtensionIndeterminate = false
      this.vectorExtensionSelectAll = false
      this.dataSets = {
        bim: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            },
            texture: {
              name: '纹理动画',
              enable: true
            },
            renderPriority: {
              name: '渲染优先级',
              enable: true
            }
          }
        },
        rs: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        wmts: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            add: {
              name: '新增地图',
              enable: true
            },
            edit: {
              name: '编辑',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        osgb: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        panorama: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        },
        pointCloud: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        },
        cad: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            }
          }
        },
        vector: {
          enable: false,
          dataSetLimit: 0,
          source: [],
          extension: [],
          menu: {
            upload: {
              name: '上传',
              enable: true
            },
            download: {
              name: '下载',
              enable: true
            },
            delete: {
              name: '删除',
              enable: true
            },
            convert: {
              name: '转换',
              enable: true
            }
          }
        }
      }
      this.scene = {
        menu: {
          addComponentLibrary: {
            name: '添加单构件模型',
            enable: false
          },
          publish: {
            name: '发布场景',
            enable: false
          }
        }
      }
      this.projects = {
        projectCountLimit: 0,
        clusterCountLimit: 0,
        sceneCountLimit: 0,
        dataSetCountLimit: 0,
        fileCountLimit: 0,
        totalFileSizeLimit: 0,
        fileCountPerProjectLimit: 0,
        dataSetCountPerProjectLimit: 0,
        sceneCountPerProjectLimit: 0
      }
      this.componentLibrary = {
        privateClFileCountLimit: 0,
        privateClFileUploadSizeLimit: 0,
        privateClFileUploadingTaskLimit: 0,
        privateClTotalFileSizeLimit: 0
      }
      this.warranty = {
        effectiveDate: '',
        globalFileUploadingTaskLimit: 0,
        globalFileUploadingSpeedLimit: 0,
        globalFileUploadSizeLimit: 0,
        convertsQueuePriority: 0
      }
      this.develop = {
        serverAdvancedInterface: false
      }
      this.exportPublish = {
        enable: false,
        isPublishPlatform: false,
        exportCountLimit: 0,
        menu: {
          exportPage: {
            name: '导出页面',
            enable: false
          },
          importPage: {
            name: '导入页面',
            enable: false
          }
        },
        platformId: '',
        platformUuid: ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.sass-config-container {
  display: flex;
  justify-content: space-between;
  height: 100%;
  text-align: left;

  .user-list-box-tree {
    height: 100%;
    width: 260px;
    padding: 16px;
  }

  .user-list-box {
    border-radius: 16px;
    background: var(--aside-page-bgColor);
    margin-right: 16px;
    transition: width 0.3s;
    position: relative;
    &:hover {
      .expaned {
        display: block;
      }
    }
    p {
      height: 20px;
      line-height: 10px;
      margin: 5px 0px;
      padding: 4px 10px;
      border-left: 4px solid var(--base-primary-color);
      color: var(--page-title-color);
    }

    .common-input-box {
      margin-top: 10px;
    }

    .list-box {
      margin-top: 10px;
      max-height: calc(100% - 60px);
      overflow-y: auto;
      overflow-x: hidden;
      color: var(--tree-node-text-color);

      li {
        padding-left: 20px;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 400;

        &:not(:last-child) {
          margin-bottom: 4px;
        }

        &:hover {
          background: var(--tree-item-hover-color);
        }
      }

      .active {
        color: var(--base-primary-color);
        background: var(--base-bg-light-color24);
      }
    }
  }

  .searchLabel {
    white-space: nowrap;
    color: var(--table-text-color);
  }
  .checkbox-gap {
    display: flex;
    flex-wrap: wrap;
    column-gap: 76px;
    margin-left: 122px;
    :deep(.el-checkbox) {
      margin-right: 0;
    }
    .checkbox-source {
      width: 96px;
    }
  }
  .user-config-box {
    width: calc(100% - 276px);
    overflow: auto;
    transition: all 0.3s;

    &-content {
      padding-bottom: 16px;
    }

    .config-item-box {
      // margin-bottom: 25px;
      padding: 8px;
      margin: 8px 16px;
      background: var(--sassConfig-item-form-bgColor);
      box-shadow: var(--base-bg-dark-color32);
      border-radius: 16px;
      border: 1px solid var(--sassConfig-item-form-border-color);

      .config-item-title-box {
        display: flex;
        justify-content: space-between;

        .common-switch-box {
          font-size: 13px;
          line-height: 30px;
          margin-right: 30px;
        }
      }

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .icon {
          width: 22px;
          height: 22px;
          border: 1px solid var(--base-primary-color);
          border-radius: 50%;
          margin-right: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .text {
          // line-height: 30px;
        }

        .extra-data {
          display: flex;
          margin-left: 10px;
          padding: 0px 20px;
          border-radius: 15px;

          .date-picker-primary {
            :deep(.el-input__inner) {
              height: 32px;
              line-height: 32px;
            }
          }
        }
      }

      .first-title {
        // margin-top: 8px;
        // height: 22px;
        .extra-data {
          display: flex;
          align-items: center;
        }
      }

      .content {
        border-radius: 0px 0px 5px 5px;
        margin-left: 30px;

        .dataset-config {
          display: flex;

          :deep(.el-checkbox) {
            .el-checkbox__label {
              color: var(--table-text-color);
            }
          }

          .select-all {
            width: 100px;
          }
        }

        .input-gap {
          column-gap: 56px;
        }
        .project-config {
          display: flex;
          align-items: center;
          &:not(:last-child) {
            padding-bottom: 8px;
          }

          .config-item {
            display: flex;
            align-items: center;

            .label {
              white-space: nowrap;
            }

            :deep(.input-number-primary) {
              .el-input__inner {
                padding-right: 18px;
                text-align: left;
              }
            }
          }

          .signFile {
            :deep(.el-input__inner) {
              margin-left: -2px;
            }
          }
        }

        .use-config {
          display: flex;

          .config-item {
            display: flex;
            align-items: center;
            .long-lable {
              // color: var(--default-color);
              text-align: right;
            }
          }
        }

        .develop-config {
          display: flex;
        }

        .first-checkbox {
          width: 70px;
        }
      }

      .fileContent {
        margin-left: 102px;

        .config-item:nth-child(2n) {
          margin-left: 33px;
        }
        .config-item:nth-child(3n) {
          margin-left: -2px;
        }
      }

      .common-bussiness-collapse-box {
        :deep(.el-collapse-item) {
          border: 1px solid var(--sassConfig-item-form-children-border-color);
          border-radius: 8px;
          .el-collapse-item__header {
            height: 32px;
            display: flex;
            align-items: center;
            background-color: var(--base-bg-dark-color33);
            padding: 0 8px;
            border-bottom: none;

            .collapse__arrow {
              color: var(--sassConfig-item-form-icon-color);
            }
          }
          .el-collapse-item__content {
            padding: 8px 30px;
            padding-left: 86px;
          }
        }

        .modelArrow {
          margin-right: 6px;
        }

        .dataset-config {
          display: flex;
          :deep(.el-checkbox) {
            .el-checkbox__label {
              color: var(--table-text-color) !important;
            }
          }
          .select-all {
            width: 100px;
            flex-shrink: 0;
          }
        }
      }
    }

    .common-button-box {
      display: flex;
      position: sticky;
      top: 0;
      background-color: var(--sassConfig-header-bgColor);
      z-index: 9;
      padding: 16px;

      .import-tips {
        margin-left: 16px;
        line-height: 32px;
      }
    }
  }

  /deep/ .el-checkbox {
    width: 90px;
  }
}

.expaned {
  width: 24px;
  height: 40px;
  border-radius: 16px;
  background-color: var(--aside-arrow-bgColor);
  box-shadow: var(--base-bg-dark-color30);
  border: 1px solid var(--aside-arrow-bgColor);
  position: absolute;
  top: 50%;
  left: 246px;
  transform: translateY(-50%);
  display: none;
  line-height: 40px;
  cursor: pointer;
  &:hover {
    background-color: var(--aside-arrow-hover-bgColor);
    box-shadow: var(--base-bg-dark-color30);
    border-color: transparent;
    border-radius: 16px;
  }

  .el-icon {
    font-weight: 600;
    color: var(--aside-arrow-expand-icon-color);
    margin-left: 50%;
    transform: translateX(-50%);
  }
}
.openTree {
  border: none;
  .expaned {
    left: -12px !important;
    z-index: 9;
    display: block !important;
  }
}

.el-picker-panel {
  border: none;
}
</style>
